export default {
  badge: 'Instellen',
  title: 'Voltooi het instellen van uw restaurant',
  description: 'Er zijn nog een paar stappen voordat uw restaurant live kan gaan.',
  count: '{{done}} van {{total}} stappen voltooid',
  cta: 'Doorgaan met instellen',
  done: {
    badge: 'Helemaal klaar',
    title: 'U bent helemaal klaar',
    description: '{{partner}} zet uw restaurant live.',
    fallback_partner: 'Uw provider',
  },
};
